export default {
    state: {
        geotabCredentials: null,
        geotabCredentialsLoaded: false,
        geotabCredentialsError: null,
    },
    actions: {
        fetchGeotabCredentials({commit, getters}, {unitId} = {}) {
            if (!getters.getApiToken || !unitId) {
                commit('setGeotabCredentialsLoaded', true)
                return Promise.resolve(null)
            }

            return new Promise((resolve, reject) => {
                this.$api.geotab.getCredentials(unitId)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('setGeotabCredentials', response.data)
                            resolve(response.data)
                        } else {
                            reject(response.data)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
                .catch((error) => {
                    console.error(error)
                    commit('setGeotabCredentialsError', error?.response?.data || error)
                    throw error
                })
                .finally(() => {
                    commit('setGeotabCredentialsLoaded', true)
                })
        },
    },
    mutations: {
        setGeotabCredentials(state, credentials) {
            state.geotabCredentials = credentials
            state.geotabCredentialsError = null
        },
        setGeotabCredentialsLoaded(state, loaded) {
            state.geotabCredentialsLoaded = loaded
        },
        setGeotabCredentialsError(state, error) {
            state.geotabCredentialsError = error
        },
        clearGeotabCredentials(state) {
            state.geotabCredentials = null
            state.geotabCredentialsLoaded = false
            state.geotabCredentialsError = null
        },
    },
    getters: {
        getGeotabCredentials(state) {
            return state.geotabCredentials
        },
        isGeotabCredentialsLoaded(state) {
            return state.geotabCredentialsLoaded
        },
        getGeotabCredentialsError(state) {
            return state.geotabCredentialsError
        },
    },
}
